import { html, unsafeCSS } from 'lit';
import { property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { Style, Variant } from '~/ui/components/tag/types';
import { SvgUtility, SvgUtilityInterface } from '~/ui/utils/icons';

import { DERElement } from '~/common/der-element';
import { styles as globalStyles } from '../../scss/main.styles';
import { styles } from './tag.styles';

export class Tag extends DERElement {
    static override styles = [unsafeCSS(globalStyles), unsafeCSS(styles)];

    @property({ type: String, reflect: true })
    variant: Variant = 'default';

    @property({ type: String, reflect: true })
    styling?: Style = 'default';

    @property({ type: String })
    icon?: keyof SvgUtilityInterface;

    override render() {
        return html`
            <div
                class=${classMap({
                    'c-tag': true,
                    'no-icon': !this.icon,
                    [this.styling || 'default']: true,
                })}
                data-tag-style-variant="${this.variant}"
            >
                <i class="c-tag__icon"
                    >${this.icon
                        ? html` <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 40 40"
                              fill="none"
                          >
                              ${SvgUtility[this.icon]}
                          </svg>`
                        : ''}</i
                >
                <slot></slot>
            </div>
        `;
    }
}
